import styled from 'styled-components';

export const Container = styled.div`
  box-sizing: border-box;
  width: 100%;
  max-width: 500px;
  margin: 0 auto;
  padding: clamp(16px, 4vw, 24px);
  min-width: 0;
`;

export const SuccessContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 40px 20px;
  animation: fadeIn 0.5s ease-in-out;

  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(10px); }
    to { opacity: 1; transform: translateY(0); }
  }
`;

export const SuccessIcon = styled.div`
  width: 80px;
  height: 80px;
  background: ${({ theme }) => theme.colors.primary.light}20;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
  color: ${({ theme }) => theme.colors.primary.main};

  svg {
    width: 40px;
    height: 40px;
  }
`;

export const SuccessTitle = styled.h2`
  font-size: 24px;
  color: ${({ theme }) => theme.colors.gray[900]};
  margin-bottom: 16px;
`;

export const SuccessMessage = styled.p`
  font-size: 16px;
  color: #666;
  line-height: 1.5;
  margin-bottom: 32px;
  max-width: 400px;

  strong {
    color: ${({ theme }) => theme.colors.primary.main};
    font-weight: 600;
  }
`;

export const Button = styled.button`
  width: 100%;
  max-width: 300px;
  height: 52px;
  border: none;
  background: ${({ theme }) => theme.colors.primary.main};
  font-size: 16px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.04);
  font-weight: bold;
  color: #fff;
  border-radius: 4px;
  transition: background 0.2s ease-in;
  cursor: pointer;

  &:hover {
    background: ${({ theme }) => theme.colors.primary.light};
  }

  &:active {
    background: ${({ theme }) => theme.colors.primary.dark};
  }

  &:disabled {
    background: #ccc;
    cursor: default;
  }
`;
